import numeral from 'numeral'
import 'numeral/locales/es'

numeral.locale('es')

export default numeral
